var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CurrentOrders',{attrs:{"orders":_vm.today_orders}}),_c('PastOrders',{attrs:{"orders":_vm.past_orders}}),(_vm.isEmpty)?_c('EmptyView',{attrs:{"text":"No Orders to Show"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }